import type { AllRouteEndpoints } from "../routeTypes";
export const appsUserInfoUserIdentifierChangeEmailCacheKeys: AllRouteEndpoints[] = [];
